var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "single container-max page-content" },
            [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 mt-3" },
                  [_vm._t("image-carousel")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6 mt-3" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "stick-in-parent",
                          rawName: "v-stick-in-parent"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between flex-column flex-md-row"
                        },
                        [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "h2 font-weight-bold d-inline-block pr-5 border-bot mb-2 mr-2",
                              attrs: { "data-testing": "item-name" }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._f("itemName")(_vm.currentVariation)
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.currentVariation.filter.hasManufacturer
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "producertag h6 producer d-none text-muted"
                                },
                                [
                                  _vm.currentVariation.item.manufacturer.logo
                                    ? _c("img", {
                                        staticClass: "img-fluid",
                                        attrs: {
                                          src:
                                            _vm.currentVariation.item
                                              .manufacturer.logo,
                                          alt:
                                            _vm.currentVariation.item
                                              .manufacturer.externalName
                                        }
                                      })
                                    : _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.externalName
                                          )
                                        }
                                      })
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm._t("tag-list"),
                      _vm._v(" "),
                      _vm.isShortDescriptionActive &&
                      _vm.currentVariation.texts.shortDescription !== ""
                        ? _c("p", {
                            staticClass: "single-description",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.shortDescription
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-5" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "articlenumber small text-muted d-block"
                          },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemNumber"
                                  )
                                ) + " "
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.currentVariation.variation.number)
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.filter.hasManufacturer
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "articlenumber small text-muted d-block"
                              },
                              [
                                _c("b", [_vm._v(" Hersteller ")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.currentVariation.item.manufacturer
                                          .externalName
                                      ) +
                                      " "
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentVariation.unit
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "fs-base-price articlenumber small text-muted d-block",
                                class: {
                                  "is-single-piece":
                                    _vm.currentVariation.unit &&
                                    _vm.currentVariation.unit.content === 1 &&
                                    _vm.currentVariation.unit
                                      .unitOfMeasurement === "C62"
                                }
                              },
                              [
                                _c("div", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemContent"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("numberFormat")(
                                          _vm.currentVariation.unit.content
                                        )
                                      ) + " "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.unit.names.name
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.currentVariation.variation.mayShowUnitPrice
                                  ? _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemUnitPrice"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "base-price-value" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("specialOffer")(
                                                  _vm.variationGraduatedPrice
                                                    .basePrice,
                                                  _vm.currentVariation.prices,
                                                  "basePrice"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "d-flex list-unstyled mb-0 mt-3 p-0 flex-wrap fs-bullets"
                          },
                          [
                            _vm.hasProp13Bullet
                              ? _c("li", {
                                  staticClass: "d-block mb-1 text-muted small",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.hasProp13Bullet)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasProp14Bullet
                              ? _c("li", {
                                  staticClass: "d-block mb-1 text-muted small",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.hasProp14Bullet)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasProp15Bullet
                              ? _c("li", {
                                  staticClass: "d-block mb-1 text-muted small",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.hasProp15Bullet)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasProp16Bullet
                              ? _c("li", {
                                  staticClass: "d-block mb-1 text-muted small",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.hasProp16Bullet)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasProp17Bullet
                              ? _c("li", {
                                  staticClass: "d-block mb-1 text-muted small",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.hasProp17Bullet)
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.attributes.length || Object.keys(_vm.units).length
                        ? _c(
                            "div",
                            { staticClass: "mb-3" },
                            [_c("variation-select")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.variation.bundleType === "bundle"
                        ? _c("item-bundle", {
                            attrs: {
                              "bundle-type":
                                _vm.currentVariation.variation.bundleType,
                              "bundle-components":
                                _vm.currentVariation.bundleComponents
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("before-price"),
                      _vm._v(" "),
                      _vm.currentVariation.filter.isSalable &&
                      _vm.variationGroupedProperties.length
                        ? _c("div", [_c("order-property-list")], 1)
                        : _vm._e(),
                      _vm._v(" "),
                      _c("graduated-prices"),
                      _vm._v(" "),
                      _c("item-price", {
                        attrs: {
                          "show-cross-price": _vm.isRecommendedPriceActive
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "vat small text-muted mb-2 ml-1d-inline-block"
                        },
                        [
                          _vm.showNetPrices
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemExclVAT"
                                    )
                                  )
                                )
                              ]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemInclVAT"
                                    )
                                  )
                                )
                              ],
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemExclusive"
                                )
                              ) +
                              "\n              "
                          ),
                          _vm.hasShippingCostsCategoryId
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    "data-toggle": "modal",
                                    href: "#shippingscosts",
                                    title: _vm.$translate(
                                      "Ceres::Template.singleItemShippingCosts"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemShippingCosts"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _c(
                                "a",
                                {
                                  attrs: {
                                    title: _vm.$translate(
                                      "Ceres::Template.singleItemShippingCosts"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemShippingCosts"
                                      )
                                    )
                                  )
                                ]
                              )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.currentVariation.prices.rrp != null
                        ? [
                            _vm.savingMoneyPercent > 0 &&
                            _vm.showSaving == "true"
                              ? _c(
                                  "div",
                                  { staticClass: "mt-0 mb-4 fs-saving" },
                                  [
                                    _c("span", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "meliorisVueTheme::Singleitem.savingMoney"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-danger" }, [
                                      _vm._v(
                                        " -" +
                                          _vm._s(
                                            _vm.savingMoneyPercent.toFixed(2)
                                          ) +
                                          "% (" +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.savingMoney.toFixed(2),
                                              _vm.currentVariation.prices
                                                .default.currency
                                            )
                                          ) +
                                          ")"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("after-price"),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "d-block" },
                        [_c("item-availability")],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentVariation.stock.net < _vm.stockNumber &&
                      _vm.showStockWarning == "true"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-warning fs-shortage p-3 my-3 d-inline-block"
                            },
                            [
                              _c("p", { staticClass: "m-0" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "meliorisVueTheme::Singleitem.shortage"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "my-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("before-add-to-basket")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.item.itemType === "set"
                          ? _c(
                              "div",
                              { staticClass: "alert alert-info w-100" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemSetInfo"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-sm-7 col-md-12 col-lg-8 my-3 pl-0"
                              },
                              [
                                _c("add-to-basket", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id,
                                    "is-salable":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-children":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter
                                        .hasActiveChildren,
                                    "interval-quantity":
                                      _vm.currentVariation.variation
                                        .intervalOrderQuantity || 1,
                                    "minimum-quantity":
                                      _vm.currentVariation.variation
                                        .minimumOrderQuantity,
                                    "maximum-quantity":
                                      !!_vm.currentVariation.variation
                                        .maximumOrderQuantity &&
                                      _vm.currentVariation.variation
                                        .maximumOrderQuantity > 0
                                        ? _vm.currentVariation.variation
                                            .maximumOrderQuantity
                                        : null,
                                    "order-properties": _vm.currentVariation.properties.filter(
                                      function(prop) {
                                        return prop.property.isOderProperty
                                      }
                                    ),
                                    "has-order-properties":
                                      _vm.currentVariation.hasOrderProperties,
                                    "has-required-order-property":
                                      _vm.currentVariation
                                        .hasRequiredOrderProperty,
                                    "use-large-scale": false,
                                    "show-quantity": true,
                                    "item-url": _vm._f("itemURL")(
                                      _vm.currentVariation
                                    ),
                                    "is-variation-selected":
                                      _vm.isVariationSelected &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-price": _vm._f("hasItemDefaultPrice")(
                                      _vm.currentVariation
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("after-add-to-basket")],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm.isWishListEnabled
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 singlewish" },
                              [
                                _c("add-to-wish-list", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showItemUsps == "true"
                        ? _c(
                            "div",
                            { staticClass: "fs-item-usps mt-md-3 mt-xl-5" },
                            [
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "d-flex list-unstyled justify-content-between flex-wrap"
                                },
                                [
                                  _vm.$translate(
                                    "meliorisVueTheme::Singleitem.ItemUspText"
                                  ) != ""
                                    ? _c("li", [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "fa",
                                            class: _vm.$translate(
                                              "meliorisVueTheme::Singleitem.ItemUspIcon"
                                            ),
                                            attrs: { "aria-hidden": "true" }
                                          },
                                          [_vm._v(" ")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "meliorisVueTheme::Singleitem.ItemUspText"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$translate(
                                    "meliorisVueTheme::Singleitem.ItemUsp2Text"
                                  ) != ""
                                    ? _c("li", [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "fa ",
                                            class: _vm.$translate(
                                              "meliorisVueTheme::Singleitem.ItemUsp2Icon"
                                            ),
                                            attrs: { "aria-hidden": "true" }
                                          },
                                          [_vm._v(" ")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "meliorisVueTheme::Singleitem.ItemUsp2Text"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$translate(
                                    "meliorisVueTheme::Singleitem.ItemUsp3Text"
                                  ) != ""
                                    ? _c("li", [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "fa ",
                                            class: _vm.$translate(
                                              "meliorisVueTheme::Singleitem.ItemUsp3Icon"
                                            ),
                                            attrs: { "aria-hidden": "true" }
                                          },
                                          [_vm._v(" ")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "meliorisVueTheme::Singleitem.ItemUsp3Text"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$translate(
                                    "meliorisVueTheme::Singleitem.ItemUsp4Text"
                                  ) != ""
                                    ? _c("li", [
                                        _c(
                                          "i",
                                          {
                                            staticClass: "fa ",
                                            class: _vm.$translate(
                                              "meliorisVueTheme::Singleitem.ItemUsp4Icon"
                                            ),
                                            attrs: { "aria-hidden": "true" }
                                          },
                                          [_vm._v(" ")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "meliorisVueTheme::Singleitem.ItemUsp4Text"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("additional-content-after-add-to-basket"),
                      _vm._v(" "),
                      _vm._t("additional-content-after-vat")
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-7 mt-3" },
                  [
                    _c("div", { staticClass: "my-5" }, [
                      _vm.showDescription == "true"
                        ? _c("div", { staticClass: "fs-description mb-5" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "h3 font-weight-bold d-inline-block pr-5 border-bot mb-2"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemDescription"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "my-4",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.currentVariation.texts.description
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTechnicalDetails == "true"
                        ? _c("div", { staticClass: "fs-technicalData" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "h3 font-weight-bold d-inline-block pr-5 border-bot mb-2"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemTechnicalData"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "my-4",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.currentVariation.texts.technicalData
                                )
                              }
                            })
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm._t("add-detail-tabs"),
                    _vm._v(" "),
                    _vm._t("add-detail-tabs-content")
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-5 mt-3 fs-bigimg" }, [
                  _vm.currentVariation.images.variation[1]
                    ? _c("img", {
                        staticClass: "img-fluid mt-5",
                        attrs: {
                          src: _vm.currentVariation.images.variation[1].url,
                          alt: _vm.currentVariation.texts.name1
                        }
                      })
                    : _vm.currentVariation.images.variation[0]
                    ? _c("img", {
                        staticClass: "img-fluid mt-5",
                        attrs: {
                          src: _vm.currentVariation.images.variation[0].url,
                          alt: _vm.currentVariation.texts.name1
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showMoreDetails == "true"
                    ? _c("div", { staticClass: "fs-details mt-5" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "h3 font-weight-bold d-inline-block pr-5 border-bot mb-2"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemMoreDetails"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "my-4" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm"
                            },
                            [
                              _c("tbody", [
                                _vm.itemConfig.includes("item.id") ||
                                _vm.itemConfig.includes("all")
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemId"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.currentVariation.item.id)
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.item.condition &&
                                _vm.currentVariation.item.condition.names
                                  .name !== "" &&
                                (_vm.itemConfig.includes("item.condition") ||
                                  _vm.itemConfig.includes("all"))
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemCondition"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item.condition
                                              .names.name
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.itemConfig.includes("item.age_rating") ||
                                _vm.itemConfig.includes("all")
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemAge"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("ageRestriction")(
                                              _vm.currentVariation.item
                                                .ageRestriction
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.variation.externalId !==
                                  "" &&
                                (_vm.itemConfig.includes("item.external_id") ||
                                  _vm.itemConfig.includes("all"))
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemExternalVariationId"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.variation
                                              .externalId
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.variation.model !== "" &&
                                (_vm.itemConfig.includes(
                                  "item.variation_model"
                                ) ||
                                  _vm.itemConfig.includes("all"))
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemModel"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.variation.model
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.filter.hasManufacturer &&
                                _vm.currentVariation.item.manufacturer
                                  .externalName !== "" &&
                                (_vm.itemConfig.includes("item.manufacturer") ||
                                  _vm.itemConfig.includes("all"))
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemManufacturer"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.externalName
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.item.producingCountry &&
                                _vm.currentVariation.item.producingCountry.names
                                  .name !== "" &&
                                (_vm.itemConfig.includes(
                                  "item.producerCountry"
                                ) ||
                                  _vm.itemConfig.includes("all"))
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemManufacturingCountry"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .producingCountry.names.name
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.unit &&
                                (_vm.itemConfig.includes(
                                  "item.variationBase_content"
                                ) ||
                                  _vm.itemConfig.includes("all"))
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemContent"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.unit.content
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.currentVariation.unit.names
                                                .name
                                            )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.variation.weightG !== "" &&
                                (_vm.itemConfig.includes("item.weightG") ||
                                  _vm.itemConfig.includes("all"))
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemWeight"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.variation
                                              .weightG
                                          ) + " g"
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.variation.weightNetG !==
                                  "" &&
                                (_vm.itemConfig.includes("item.weightNetG") ||
                                  _vm.itemConfig.includes("all"))
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemNetWeight"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.variation
                                              .weightNetG
                                          ) + " g"
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.itemConfig.includes(
                                  "item.variation_dimensions"
                                ) || _vm.itemConfig.includes("all")
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemDimensions"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.variation
                                                .lengthMM
                                            )
                                          )
                                        ]),
                                        _vm._v("×\n                    "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.variation
                                                .widthMM
                                            )
                                          )
                                        ]),
                                        _vm._v("×\n                    "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.variation
                                                .heightMM
                                            )
                                          )
                                        ]),
                                        _vm._v(
                                          "\n                    mm\n                  "
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentVariation.variation
                                  .customsTariffNumber !== "" &&
                                (_vm.itemConfig.includes(
                                  "variation.customs_tariff_number"
                                ) ||
                                  _vm.itemConfig.includes("all"))
                                  ? _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemCustomsTariffNumber"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.variation
                                              .customsTariffNumber
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm._t("item-list-container"),
              _vm._v(" "),
              _vm._t("feedback-container")
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "mobile-buybtn" } }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex d-sm-none py-2 px-3 align-items-center flex-wrap"
              },
              [
                _vm.attributes.length || Object.keys(_vm.units).length
                  ? _c(
                      "div",
                      { staticClass: "vselect mr-3" },
                      [_c("variation-select")],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mobile-add" }, [
                  _vm.currentVariation.item.itemType === "set"
                    ? _c("div", { staticClass: "alert alert-info w-100" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.singleItemSetInfo"
                              )
                            ) +
                            "\n          "
                        )
                      ])
                    : _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-sm-7 col-md-12 col-lg-8 mb-3 px-0"
                        },
                        [
                          _c("add-to-basket", {
                            attrs: {
                              "variation-id": _vm.currentVariation.variation.id,
                              "is-salable":
                                !!_vm.currentVariation.filter &&
                                _vm.currentVariation.filter.isSalable,
                              "has-children":
                                !!_vm.currentVariation.filter &&
                                _vm.currentVariation.filter.hasActiveChildren,
                              "interval-quantity":
                                _vm.currentVariation.variation
                                  .intervalOrderQuantity || 1,
                              "minimum-quantity":
                                _vm.currentVariation.variation
                                  .minimumOrderQuantity,
                              "maximum-quantity":
                                !!_vm.currentVariation.variation
                                  .maximumOrderQuantity &&
                                _vm.currentVariation.variation
                                  .maximumOrderQuantity > 0
                                  ? _vm.currentVariation.variation
                                      .maximumOrderQuantity
                                  : null,
                              "order-properties": _vm.currentVariation.properties.filter(
                                function(prop) {
                                  return prop.property.isOderProperty
                                }
                              ),
                              "has-order-properties":
                                _vm.currentVariation.hasOrderProperties,
                              "has-required-order-property":
                                _vm.currentVariation.hasRequiredOrderProperty,
                              "use-large-scale": false,
                              "show-quantity": true,
                              "item-url": _vm._f("itemURL")(
                                _vm.currentVariation
                              ),
                              "is-variation-selected":
                                _vm.isVariationSelected &&
                                _vm.currentVariation.filter.isSalable,
                              "has-price": _vm._f("hasItemDefaultPrice")(
                                _vm.currentVariation
                              )
                            }
                          })
                        ],
                        1
                      )
                ])
              ]
            )
          ])
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }